import { render, staticRenderFns } from "./BulkImportTab.vue?vue&type=template&id=4a6f7c50&scoped=true"
import script from "./BulkImportTab.vue?vue&type=script&lang=js"
export * from "./BulkImportTab.vue?vue&type=script&lang=js"
import style0 from "./BulkImportTab.vue?vue&type=style&index=0&id=4a6f7c50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f7c50",
  null
  
)

export default component.exports